interface TypeChecker {
  isArray?(value: any): boolean
  isObject?(value: any): boolean
  isString?(value: any): boolean
  isDate?(value: any): boolean
  isRegExp?(value: any): boolean
  isFunction?(value: any): boolean
  isBoolean?(value: any): boolean
  isNumber?(value: any): boolean
  isNull?(value: any): boolean
  isUndefined?(value: any): boolean
}

const types = ['Array', 'Object', 'String', 'Date', 'RegExp', 'Function', 'Boolean', 'Number', 'Null', 'Undefined']

export default (() => {
  const typeChecker: TypeChecker = {}

  // ex. [object String] => String, [object Date] => Date
  const getType = elem => {
    return Object.prototype.toString.call(elem).slice(8, -1)
  }

  types.forEach(type => {
    typeChecker[`is${type}`] = (type => elem => getType(elem) === type)(type)
  })

  return typeChecker
})()
